import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useInView } from '@blaze-react/utils/lib/customHooks';
import { IN_VIEW_CONFIG } from '../../../../constants';
import { getPosterUrl, YT_HQ_FORMAT, YT_IMAGE_URL } from './helpers';
const YoutubeEmbeded = ({
  autoplay,
  videoId,
  playlistCoverId,
  videoTitle,
  poster,
  videoParams,
  announce,
  noCookie,
  webp,
  playlist,
  onIframeAdded,
  muted,
  adNetwork,
  iframeClass,
  priority,
  placeholderOnly,
  imageData
}) => {
  const [isIntersecting, outerRef] = useInView(IN_VIEW_CONFIG);
  const [preconnected, setPreconnected] = useState(false);
  const [renderIframe, setRenderIframe] = useState(!!autoplay);
  const [{
    imageSize,
    displayImage
  }, setImageDetails] = useState({
    imageSize: poster,
    displayImage: priority
  });
  const encodedId = encodeURIComponent(videoId);
  const paramsImp = videoParams ? `&${videoParams}` : '';
  const ytUrl = noCookie ? 'https://www.youtube-nocookie.com' : 'https://www.youtube.com';
  const posterUrl = getPosterUrl({
    imageData,
    playlistCoverId,
    playlist,
    encodedId,
    imageSize,
    webp
  });
  const mutedValue = muted ? '&mute=1' : '';
  const iframeSrc = !playlist ? `${ytUrl}/embed/${encodedId}?autoplay=1${mutedValue}${paramsImp}` : `${ytUrl}/embed/videoseries?autoplay=1${mutedValue}&list=${encodedId}${paramsImp}`;
  const parsedWrapperClassname = `yt-facade ${renderIframe ? 'yt-activated' : ''}`;
  useEffect(() => {
    let isMounted = true;
    if (!priority && !isIntersecting || imageSize === YT_HQ_FORMAT) return;
    const img = new Image();
    // eslint-disable-next-line func-names
    img.onload = function () {
      let newImageSize = imageSize;
      if (this && this.width === 120) newImageSize = YT_HQ_FORMAT;
      if (isMounted) setImageDetails({
        imageSize: newImageSize,
        displayImage: true
      });
    };
    img.src = posterUrl;
    return () => {
      isMounted = false;
    };
  }, [imageSize, isIntersecting, posterUrl, priority]);
  const warmConnections = () => {
    if (preconnected) return;
    setPreconnected(true);
  };
  const addIframe = () => {
    if (renderIframe || placeholderOnly) return;
    onIframeAdded();
    setRenderIframe(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, preconnected && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: YT_IMAGE_URL
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: ytUrl
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://www.google.com"
  }), adNetwork && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://static.doubleclick.net"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://googleads.g.doubleclick.net"
  }))), /*#__PURE__*/React.createElement("div", {
    ref: outerRef,
    role: "button",
    onPointerOver: warmConnections,
    onClick: addIframe,
    className: parsedWrapperClassname,
    "data-title": videoTitle,
    "aria-label": `View ${videoTitle || 'video'}`,
    style: {
      backgroundImage: `url(${displayImage ? posterUrl : ''})`
    }
  }, /*#__PURE__*/React.createElement("div", {
    type: "button",
    className: "yt-facade-button-wrapper",
    "aria-label": `${announce} ${videoTitle}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "yt-facade-button"
  })), renderIframe && /*#__PURE__*/React.createElement("iframe", {
    className: iframeClass,
    title: videoTitle,
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    src: iframeSrc
  })));
};
YoutubeEmbeded.propTypes = {
  priority: PropTypes.bool,
  onIframeAdded: PropTypes.func,
  adNetwork: PropTypes.bool,
  autoplay: PropTypes.bool,
  playlist: PropTypes.bool,
  muted: PropTypes.bool,
  webp: PropTypes.bool,
  noCookie: PropTypes.bool,
  videoId: PropTypes.string,
  iframeClass: PropTypes.string,
  poster: PropTypes.string,
  announce: PropTypes.string,
  playlistCoverId: PropTypes.string,
  videoParams: PropTypes.string,
  videoTitle: PropTypes.string,
  placeholderOnly: PropTypes.bool,
  imageData: PropTypes.object
};
YoutubeEmbeded.defaultProps = {
  priority: true,
  onIframeAdded: () => {},
  adNetwork: false,
  autoplay: false,
  playlist: false,
  muted: false,
  webp: false,
  noCookie: false,
  iframeClass: '',
  poster: 'sddefault',
  announce: 'Watch',
  videoId: '',
  playlistCoverId: '',
  videoParams: '',
  videoTitle: '',
  placeholderOnly: false,
  imageData: {}
};
export default YoutubeEmbeded;
//# sourceMappingURL=YoutubeEmbeded.js.map